import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AddRoomSuccessModalComponent } from '../add-room-success-modal/add-room-success-modal.component';
import { faTimes, faCircleNotch, faCheck, faInfoCircle, faPencil } from '@fortawesome/pro-light-svg-icons';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModalComponent, modals } from '@clooper/modals';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GeneralService, IRoom, Property, PROPERTY, PropertyService, RoomService } from '@clooper/core';
import { PropertyDescriptionPipe } from '@clooper/common';

@Component({
  selector: 'app-add-room-modal',
  templateUrl: './add-room-modal.component.html',
  styleUrls: ['./add-room-modal.component.scss']
})
export class AddRoomModalComponent implements OnInit {
  propertyDetails: Property;
  rooms: IRoom[];
  roomId: string;
  activeTab = '';
  loading = false;
  roomDetails: IRoom
  isEditMode = false;
  enableTab = true;

  rentCycles = Object.values(PROPERTY.RENT_CYCLES);

  icons = {
    times: faTimes,
    spinner: faCircleNotch,
    check: faCheck,
    info: faInfoCircle,
    pencil: faPencil
  }
  form = this.fb.group({
    display_name: ['', [Validators.required]],
    rent: this.fb.group({
      amount: ['', [Validators.required]],
      holding_deposit: [{ value: '' }, [Validators.required]],
      security_deposit: [{ value: '' }, [Validators.required]],
      cycle: [this.rentCycles[0], [Validators.required]],
      bills_included: [[]],
    }),
    available_from: ['', [Validators.required]],
    description: ['', [Validators.required]]
  })
  billsFormData = { label: 'Bills (Optional)', placeholder: 'Enter your own bills' }
  constructor(
    private fb: FormBuilder,
    private gs: GeneralService,
    public bsModalRef: BsModalService,
    private roomService: RoomService,
    private descriptionPipe: PropertyDescriptionPipe,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.roomService.setParent(this.propertyDetails.id);
    this.onMonthlyRentChange();
    if (this.isEditMode) {
      this.getRoom()
    } else {
      this.autoFillRoomTitle();
      this.getDescription()
    }
  }

  get rentForm(): FormGroup {
    return (this.form.get('rent') as FormGroup);
  }
  // Form Validations
  get isDisNameValid() { return (this.form.get('display_name')?.valid as boolean) };
  get isRentValid() { return (this.form.get('rent')?.valid as boolean) }
  get isAvialDateValid() { return (this.form.get('available_from')?.valid as boolean) }
  get isDescValid() { return (this.form.get('description')?.valid as boolean) }

  onMonthlyRentChange() {
    // this.rentForm?.get('amount')?.valueChanges.subscribe(amount => {
    //   if (amount && this.rentForm.get('cycle')?.value === PROPERTY.RENT_CYCLES.MONTHLY) {
    //     const oneWeekRent = this.floatNum((amount * 12) / 52.143);
    //     this.rentForm.get('holding_deposit')?.setValue(oneWeekRent);
    //     this.rentForm.get('security_deposit')?.setValue(this.floatNum(oneWeekRent * 5));
    //   } else {
    //     this.rentForm.get('holding_deposit')?.setValue(0);
    //     this.rentForm.get('security_deposit')?.setValue(0);
    //   };
    // })
  }

  floatNum(value: number, decimalPlace = 2) {
    return Number(Number(value).toFixed(decimalPlace))
  }

  autoFillRoomTitle() {
    if (!this.propertyDetails) return;
    const title = `Room ${this.rooms.length + 1} in ${this.propertyDetails.display_name}`;
    this.form.get('display_name')?.setValue(title);
  }

  toggleTab(tab: string) {
    if (tab === 'description') {
      this.getDescription();
    }
    if (this.isEditMode) {
      this.activeTab = tab;
    } else {
      this.enableTab = false;
      setTimeout(() => {
        this.activeTab = tab;
        this.enableTab = true;
      }, 1000);
    }
  }

  handleNext(curTab: any, nextTab: string) {
    if (curTab == 'photos') {
      this.toggleTab(nextTab)
      return;
    }
    const { id } = this.propertyDetails;
    const formValues = this.stepForm[curTab];
    let obs = this.roomService.create(formValues);
    if (this.roomId || curTab !== 'general') {
      const payload = { ...formValues, id: this.roomId }
      obs = this.roomService.update(payload);
    }
    this.handleRoomObs(obs, nextTab);
  }

  handleRoomObs(observable: Observable<any>, nextTab: string) {
    this.loading = true;
    observable.subscribe((res: any) => {
      this.roomId = res.data ? res.data.room.id : (res.room ? res.room.id : res.id);
      if (nextTab == 'finish') {
        this.handleFinish()
      } else {
        this.toggleTab(nextTab)
      }
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err))
    }).add(() => this.loading = false)
  }

  handleFinish() {
    const action = this.isEditMode ? 'Update' : 'Added';
    this.toastr.success(`Room ${action} Successfully`)
    this.bsModalRef.hide();
  }

  photosSelected(event: any) {
    const file = event?.target.files;
  }

  get genNextBtnState(): boolean {
    const state: boolean = this.isDisNameValid && this.isAvialDateValid;
    return state
  }

  getRoom() {
    this.roomService.get(this.roomId).subscribe((room: any) => {
      this.roomDetails = room
      this.fillForm(room);
    })
  }

  fillForm(room: IRoom) {
    room.available_from = this.gs.getDateVal(room.available_from);
    this.form.patchValue(room);
  }

  get stepForm(): any {
    const { rent, display_name, available_from, description } = this.form.getRawValue();
    const result = {
      general: { display_name, available_from },
      rent: { rent },
      description: { description, display_name }
    }
    return result
  }

  getDescription() {
    const payload = { ...this.propertyDetails, ...this.form.value }
    const result = this.descriptionPipe.transform(payload, 'room');
    this.form.get('description')?.setValue(result);
  }
}
